// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CrmUserRepoConfig from "./CrmUserRepoConfig.bs.js";

var userDummyResponse = {
      "admin": {
        "name" : "TEST TEST",
        "id": 123,
        "email": "test.TEST@example.com",
        "crt_id": "0000474984"
      }
    };

function fetchCurrentUser(_country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: userDummyResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CrmUserRepoConfig.UserResponseConverter.execute, result);
                        });
            });
}

var T = {
  fetchCurrentUser: fetchCurrentUser
};

export {
  T ,
  
}
/* CrmUserRepoConfig Not a pure module */
